export default __webpack_public_path__ + "assets/mp3.c4f6cf8e048c8d1fd70ea5676f9e35bb.png";